export const SETTINGS_PREFIX_KEY = "@hc-settings-"
